import React from 'react';
import {
  Card, CardBody, Col,
} from 'reactstrap';
import PlusCircleIcon from 'mdi-react/PlusCircleIcon';
import PropTypes from 'prop-types';

const renderTxt = (mainCategory) => {
  if (mainCategory === 'data') return 'compte';
  if (mainCategory === 'cloud') return 'cloud';
  return 'bien';
};

const AddCard = ({
  openModalAdd,
  mainCategory,
}) => (
  <Col className="mb-10" xs={6} sm={4} md={4} lg={3} xl={2}>
    <Card style={{ paddingBottom: 10 }}>
      <CardBody className="addCard assetCard canClick fullCenter" onClick={() => openModalAdd(mainCategory)}>
        <div className="card__title mb-0">
          <PlusCircleIcon size="50" color="#eba64c" />
          <h5 className="bold-text mt-20 fs12">Ajouter un {renderTxt(mainCategory)}</h5>
        </div>
      </CardBody>
    </Card>
  </Col>
);

AddCard.propTypes = {
  openModalAdd: PropTypes.func,
  mainCategory: PropTypes.string.isRequired,
};

AddCard.defaultProps = {
  openModalAdd: () => {},
};

export default AddCard;
